enum BulkType {
    Dictate = 1,
    Validate = 2,
    Mixed = 3
}

export default BulkType;